import type { Surface, SurfaceRole } from './types';

/** Omitted roles preserve the exact historical designated-panel meaning. */
export function surfaceRole(surface: Pick<Surface, 'role'>): SurfaceRole {
  const role = surface.role;
  if (role === undefined) return 'panel';
  if (role === 'panel' || role === 'fascia' || role === 'exclusion') return role;
  throw new Error('Invalid surface role.');
}
export function isPaintableSurface(surface: Pick<Surface, 'role'>): boolean {
  return surfaceRole(surface) !== 'exclusion';
}
/** Room policy changes authoring eligibility, never physical masks or saved display. */
export function isAuthorableSurface(surface: Pick<Surface, 'role'>, freestyleEnabled=true): boolean {
  return isPaintableSurface(surface) && (freestyleEnabled || surfaceRole(surface) !== 'fascia');
}
export function isFrontierPanel(surface: Pick<Surface, 'role'>): boolean {
  return surfaceRole(surface) === 'panel';
}
